module.exports = __webpack_public_path__ + "static/media/screen3.42ec1728.png";